import { AudioManager } from "../../../AudioManager";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";

export class CombosContainer extends Phaser.GameObjects.Container {

    public static LABEL_COLOURS = [0x08D6FF, 0xF6C713, 0xFD2958, 0xED3EFF, 0xFF8502, 0x52EF1F];

    private rematchesCounter: number;
    private cat: Phaser.GameObjects.Image;
    private tweening: boolean;
    private comboLabelContainer: Phaser.GameObjects.Container;
    private comboLabel: Phaser.GameObjects.Image;
    private comboLabelInline: Phaser.GameObjects.Image;
    private rematchesLabel1: Phaser.GameObjects.Image;
    private rematchesLabelInline1: Phaser.GameObjects.Image;
    private rematchesLabel2: Phaser.GameObjects.Image;
    private rematchesLabelInline2: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.tweening = false;
        this.rematchesCounter = 0;

        this.comboLabelContainer = new Phaser.GameObjects.Container(this.scene);
        this.comboLabelContainer.x = GameConstants.GAME_WIDTH / 2;
        this.comboLabelContainer.y = GameConstants.GAME_HEIGHT / 2;
        this.comboLabelContainer.scaleY = GameVars.scaleY;
        this.add(this.comboLabelContainer);

        this.comboLabelContainer.visible = false;

        this.comboLabel = new Phaser.GameObjects.Image(this.scene, -40, 0, "texture_atlas_7", "combo_x");
        this.comboLabel.tint = 0x08D6FF;
        this.comboLabelContainer.add(this.comboLabel);

        this.comboLabelInline = new Phaser.GameObjects.Image(this.scene, -40, 0, "texture_atlas_7", "combo_x_inline");
        this.comboLabelContainer.add(this.comboLabelInline);

        this.rematchesLabel1 = new Phaser.GameObjects.Image(this.scene, 150, 0, "texture_atlas_7", "number_1");
        this.rematchesLabel1.tint = 0x08D6FF;
        this.comboLabelContainer.add(this.rematchesLabel1);

        this.rematchesLabelInline1 = new Phaser.GameObjects.Image(this.scene, 150, 0, "texture_atlas_7", "number_1_inline");
        this.comboLabelContainer.add(this.rematchesLabelInline1);

        this.rematchesLabel2 = new Phaser.GameObjects.Image(this.scene, 212, 0, "texture_atlas_7", "number_1");
        this.rematchesLabel2.tint = 0x08D6FF;
        this.comboLabelContainer.add(this.rematchesLabel2);

        this.rematchesLabelInline2 = new Phaser.GameObjects.Image(this.scene, 212, 0, "texture_atlas_7", "number_1_inline");
        this.comboLabelContainer.add(this.rematchesLabelInline2);

        this.rematchesLabel2.visible = false;
        this.rematchesLabelInline2.visible = false;

        this.cat = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT, "texture_atlas_1", "combox3");
        this.cat.setOrigin(1);
        this.cat.scaleY = GameVars.scaleY;
        this.add(this.cat);

        this.cat.visible = false;
    }

    public update(): void {

        if (this.cat.visible && !this.tweening) {

            let d: number;

            if (this.rematchesCounter >= 9) {
                d = 4;
            } else if (this.rematchesCounter >= 6) {
                d = 2;
            } else {
                d = .75;
            }

            this.cat.x = GameConstants.GAME_WIDTH + 10 + d - 2 * d * Math.random();
            this.cat.y = GameConstants.GAME_HEIGHT + 10 * GameVars.scaleY + d - 2 * d * Math.random();
        }
    }

    public onRematch(rematchesCounter: number): void {

        this.rematchesCounter = rematchesCounter;

        if (this.rematchesCounter === 3) {

            this.cat.visible = true;
            this.cat.setFrame("combox3");

            this.cat.x = GameConstants.GAME_WIDTH + 185;
            this.cat.y = GameConstants.GAME_HEIGHT + 185 + GameVars.scaleY;

            this.tweening = true;

            this.scene.tweens.add({
                targets: this.cat,
                x: GameConstants.GAME_WIDTH + 10,
                y: GameConstants.GAME_HEIGHT + 10 * GameVars.scaleY,
                ease: Phaser.Math.Easing.Back.Out,
                duration: 200,
                onComplete: function (): void {
                    this.tweening = false;
                },
                onCompleteScope: this
            });

        } else if (this.rematchesCounter === 6) {

            this.cat.setFrame("combox6");
             
            this.tweening = true;

            this.scene.tweens.add({
                targets: this.cat,
                x: GameConstants.GAME_WIDTH + 30,
                y: GameConstants.GAME_HEIGHT + 30 * GameVars.scaleY,
                ease: Phaser.Math.Easing.Cubic.InOut,
                duration: 150,
                yoyo: true,
                onComplete: function (): void {
                    this.tweening = false;
                },
                onCompleteScope: this
            });

        } else if (this.rematchesCounter === 9) {

            this.cat.setFrame("combox9");

            this.tweening = true;

            this.scene.tweens.add({
                targets: this.cat,
                x: GameConstants.GAME_WIDTH + 30,
                y: GameConstants.GAME_HEIGHT + 30 * GameVars.scaleY,
                ease: Phaser.Math.Easing.Cubic.InOut,
                duration: 150,
                yoyo: true,
                onComplete: function (): void {
                    this.tweening = false;
                },
                onCompleteScope: this
            });
        }

        this.setCombosLabel();

        const i = rematchesCounter - 2;

        if (i >= 1 && i < 9) {

            this.scene.time.delayedCall(300, function(): void {
                AudioManager.playSound("Rising Combo Hit 0" + i, false, 1.5);
            }, [], this);   
           
        } else if (i >= 9) {
            
            this.scene.time.delayedCall(300, function(): void {
                AudioManager.playSound("Rising Combo Hit Bonus", false, 1.5);
            }, [], this);  
        }
    }

    public onNoRematch(): void {
        
        this.tweening = true;

        this.scene.tweens.add({
            targets: this.cat,
            x: GameConstants.GAME_WIDTH + 185,
            y: GameConstants.GAME_HEIGHT + 185 * GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            onComplete: function (): void {
                this.tweening = false;
                this.cat.visible = false;
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: this.comboLabelContainer,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450,
            onComplete: function (): void {
                this.comboLabelContainer.visible = false;

                this.rematchesLabel2.visible = false;
                this.rematchesLabelInline2.visible = false;
            },
            onCompleteScope: this
        });
    }

    private setCombosLabel(): void {

        if (this.rematchesCounter === 3) {
            this.comboLabelContainer.visible = true;
            this.comboLabelContainer.alpha = 1;
            this.comboLabelContainer.scaleX = 1;
            this.comboLabelContainer.scaleY = GameVars.scaleY;
        }

        let i = this.rematchesCounter - 3;
        i = i % CombosContainer.LABEL_COLOURS.length;

        this.comboLabel.tint = CombosContainer.LABEL_COLOURS[i];
        this.rematchesLabel1.tint = CombosContainer.LABEL_COLOURS[i];
        this.rematchesLabel2.tint = CombosContainer.LABEL_COLOURS[i];
        
        if (this.rematchesCounter <= 9) {

            this.rematchesLabel1.setFrame("number_" + this.rematchesCounter);
            this.rematchesLabelInline1.setFrame("number_" + + this.rematchesCounter + "_inline");

            const s = this.comboLabelContainer.scaleX * 1.06;

            this.scene.tweens.add({
                targets: this.comboLabelContainer,
                scaleX: s,
                scaleY: s * GameVars.scaleY,
                ease: Phaser.Math.Easing.Bounce.InOut,
                duration: 250
            });

        } else {

            this.rematchesLabel2.visible = true;
            this.rematchesLabelInline2.visible = true;

            const d = Math.floor(this.rematchesCounter / 10);
            const u = this.rematchesCounter % 10;

            this.rematchesLabel1.setFrame("number_" + d);
            this.rematchesLabelInline1.setFrame("number_" + + d + "_inline");

            this.rematchesLabel2.setFrame("number_" + u);
            this.rematchesLabelInline2.setFrame("number_" + + u + "_inline");
        }
    }
}
